<div class="container mt-4" dir="rtl">
  <h3>مدیریت مطالب</h3>

  <!-- دکمه افزودن مطلب -->
  <div class="d-flex justify-content-end mb-3">
    <button class="btn btn-primary" (click)="openModal()">افزودن مطلب</button>
  </div>

  <!-- 🔍 نوار جستجو -->
  <div class="mb-3">
    <input
      type="text"
      class="form-control shadow-sm"
      placeholder="جستجوی عنوان یا متن..."
      [(ngModel)]="searchText"
      (input)="onSearch()"
    />
  </div>

  <!-- 🟪 نسخه موبایل: نمایش کارتی -->
  <div class="d-block d-md-none">
    <div *ngFor="let item of filteredList" class="card mb-3 shadow-sm">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ item.title }}</h5>
        <p
          class="card-text text-primary"
          style="cursor:pointer;"
          (click)="openDetailModal(item)"
        >
          {{ item.text | slice:0:80 }}...
        </p>

        <div class="mt-2 text-end">
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">
            ✏️ ویرایش
          </button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">🗑 حذف</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 🟦 نسخه دسکتاپ: جدول مدرن -->
  <div class="table-responsive d-none d-md-block">
    <table
      class="table table-hover table-striped align-middle shadow-sm rounded text-end"
    >
      <thead class="table-primary">
        <tr>
          <!-- عرض ستون عنوان محدودتر شد -->
          <th style="width: 15%;">عنوان</th>
          <th style="width: 40%;">متن (برای مشاهده کامل کلیک کنید)</th>
          <!-- عرض ستون عملیات تنظیم شد -->
          <th style="width: 45%; text-align: right;">عملیات</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of filteredList">
          <!-- نمایش حدود 5 کلمه اول عنوان -->
          <td style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <strong>{{ item.title }}</strong>
          </td>

          <td>
            <span
              class="text-primary"
              style="cursor:pointer;"
              (click)="openDetailModal(item)"
            >
              {{ item.text | slice:0:60 }}...
            </span>
          </td>

          <td>
            <!-- دکمه ها در یک div قرار گرفتند و راست چین شدند -->
            <div class="d-flex justify-content-end flex-wrap" style="gap: 0.5rem;">
              <button
                class="btn btn-warning btn-sm"
                (click)="openEditModal(item)"
              >
                ✏️ ویرایش
              </button>
              <button
                class="btn btn-danger btn-sm"
                (click)="delete(item.id)"
              >
                🗑 حذف
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal افزودن/ویرایش -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered"> <!-- modal-lg برای عرض بیشتر و modal-dialog-centered برای وسط چین شدن -->
      <div class="modal-content" dir="rtl">
        <div class="modal-header bg-primary text-white"> <!-- هدر با رنگ اصلی و متن سفید -->
          <h5 class="modal-title">{{ anyObj.id ? 'ویرایش مطلب' : 'افزودن مطلب' }}</h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            (click)="closeModal()"
          ></button>
        </div>

        <div class="modal-body p-4">
          <form id="userForm">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">عنوان</label>     <!--فونت ضخیم تر برای لیبل -->
                <input
                  type="text"
                  [(ngModel)]="anyObj.title"
                  name="title"
                  class="form-control form-control-lg shadow-sm"
                  placeholder="عنوان"required
                />
              </div>

              <div class="col-md-12">
                <label class="form-label fw-bold">متن کامل</label>
                <textarea
                  [(ngModel)]="anyObj.text"
                  name="text"
                  class="form-control form-control-lg shadow-sm"
                  placeholder="متن"
                  rows="6"
                  required
                ></textarea>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
          <button (click)="onSave()" class="btn btn-success">
            {{ anyObj.id ? 'ذخیره تغییرات' : 'افزودن' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 🟦 Modal نمایش متن کامل -->
  <div class="modal fade" #detailModal tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" dir="rtl" style="word-wrap: break-word; overflow-wrap: break-word;">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ detailObj?.title }}</h5>
          <button class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div
          class="modal-body"
          style="white-space: pre-line; text-align: justify; word-break: break-word;"
        >
          <p class="fs-6">{{ detailObj?.text }}</p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
        </div>
      </div>
    </div>
  </div>
</div>
